/** Value of a Cognito user attribute, or '' when absent. */
export const getCognitoAttribute = (user, name) =>
  user.UserAttributes?.find((attribute) => attribute.Name === name)?.Value || '';

/** A Cognito user's stable id (`sub`); the DELETE /users/{userId} path parameter. */
export const getUserId = (user) => getCognitoAttribute(user, 'sub');

export const getUserEmail = (user) => getCognitoAttribute(user, 'email');
